const TechnicalLV11 = () => {
    return (
        <div>
            <p><span style={ { fontSize: "24px" } }><strong>ContiSeal</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>ContiSeal<sup>TM</sup></strong> - uzlabotai mobilitātei un drošībai pat tad, ja riepas protektora daļā ir iedūries svešķermenis.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Tehnoloģija</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>ContiSeal<sup>TM</sup></strong> riepām ir inovatīvas tehnoloģijas pārklājums riepas iekšpusē, kas noblīvē protektora daļu. Tām ir lipīgs un viskozs polimēru slānis no viena pleca līdz otram, kas aizsargā riepu no gaisa nolaišanas gadījumā, ja protektora daļā ir iedūrusies nagla, skrūve vai kāds cits objekts diametrā līdz 5 mm. Materiāls hermētiskajā slānī novērš gaisa izplūšanu pat tad, ja svešķermenis ir izkritis no dūriena vietas.</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tādējādi, riepas pārduršanas gadījumā nav nepieciešams veikt piespiedu apstāšanos, lai nomainītu riepu. Tomēr pārdurtu riepu pēc iespējas ātrāk vajadzētu nogādāt pie riepu servisa speciālistiem, kas konstatēs bojājumu un nepieciešamības gadījumā veiks remontu.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Atpazīšana</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<strong>ContiSeal<sup>TM</sup></strong> riepas var atpazīt pēc naglas simbola, kas attēlots uz riepas sānu malas:</p>

            <p>&nbsp;</p>

            <p><img alt="" src="http://adm.tireshop.lv/upload/pictures/584/content_maxresdefault_conti.jpg" style={ { width: "min(100%, 500px)", height: "auto", display: "block", margin: "auto" } } /></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Riepas ir montējamas uz visiem riteņu diskiem. Citādi tās saglabā normālas riepas veiktspēju.</p>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>Ieguvumi</strong></span></p>

            <p>&nbsp;</p>

            <ul>
                <li>Noblīvē dūriena vietas protektora zonā, ja tās nepārsniedz 5 mm diametrā</li>
                <li>Dūriena vietas tiek noblīvētas pat tad, ja svešķermenis izkritis no dūriena vietas</li>
                <li>Normālos braukšanas apstākļos nodrošina tādas pat braukšanas īpašības kā standarta riepas</li>
                <li>Riepas pārduršanas gadījumā nav nepieciešams veikt piespiedu apstāšanos vai nekavējoties mainīt riepu</li>
            </ul>

            <p>&nbsp;</p>

            <p><span style={ { fontSize: "24px" } }><strong>ContiSeal riepu izmantošana</strong></span></p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tāpat kā jebkuru citu riepu, regulāri jāpārbauda arī <strong>ContiSeal</strong> riepas, vai tās nav caurdurtas, pārgrieztas un vai tajās nav radies gaisa spiediena zudums. <strong>ContiSeal</strong> riepas vajadzētu pārbaudīt vismaz vienu vai divas reizes mēnesī, kā arī vienmēr pirms garākiem braucieniem. Laikus nekonstatētas dūriena un iegriezuma vietas var radīt gaisa spiediena zudumu un/vai riepas bojājumus. Ja <strong>ContiSeal</strong> riepa ir caurdurta vai tajā atklāts bojājums, to nekavējoties vajadzētu uzpildīt ar gaisa spiedienu pēc nepieciešamības. Caurdurtas vai pārgrieztas <strong>ContiSeal</strong> riepas nekavējoties jānogādā profesionāliem riepu speciālistiem, kuri atbilstoši standartiem veiks rūpīgu riepu pārbaudi un noteiks, vai nepieciešams riepas remonts vai arī riepa vairs nav derīga. Lai veiktu riepas remontu, tā būs jādemontē no diska un jāpielieto <strong>ContiSeal</strong> riepām piemērota remonta metode. Riepu remonta speciālisti no kompānijas <strong>Rema TipTop</strong> ir izstrādājuši un apstiprinājuši <strong>ContiSeal</strong> riepu remonta instrukcijas.</p>

            <p>&nbsp;</p>

            <p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Lai gan <strong>ContiSeal</strong> ievērojami samazina gaisa spiediena zudumu riepās caurduršanas gadījumā, autovadītājam jāseko līdzi jebkādām izmaiņām braukšanas dinamikā (trokšņa līmenis, vibrācija vai vadāmība). Šādas izmaiņas var liecināt par nepieciešamību pārbaudīt vienu vai vairākas riepas specializētā riepu servisā.</p>
        </div>
    );
};

export default TechnicalLV11;


